<!-- /* * Confidential and Proprietary. * Do not distribute without 1-800-Flowers.com, Inc. consent. *
Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved. */ -->

{#if $chatPreviewMsgVisible && $chatSession.flags?.['chat-show-preview-enabled']}
	<div class="preview-container">
		<div class="preview-container-content">
			<button data-testid="preview-close-button" class="close-button" on:click={handlePreviewMsgClose}
				>X</button
			>
			<div data-testid="preview-bounce" class="previewContainer bounce">
				<button data-testid="preview-message" class="preview-message" on:click={toggleChat}
					>{$chatPreviewMsgVerbiage ||
						'Get help with shopping, comparing products, order support, and more.'}
				</button>
			</div>
		</div>
	</div>
{/if}

<script lang="ts">
	import {
		chatPreviewMsgVisible,
		chatSession,
		chatPreviewMsgVerbiage
	} from '$lib/stores/chatSessionStore';
	export let toggleChat: () => Promise<void>;

	const handlePreviewMsgClose = () => {
		chatPreviewMsgVisible.update(() => false);
		// send event to mbp-pwa-ui
		window.parent.postMessage(
			{
				type: 'flora-chat-preview-msg-closed'
			},
			'*'
		);
	};
</script>

<style>
	@keyframes bounce {
		0%,
		20%,
		50%,
		80%,
		100% {
			transform: translateY(0);
		}

		40% {
			transform: translateY(-30px);
		}

		60% {
			transform: translateY(-15px);
		}
	}

	.preview-container {
		position: fixed;
		bottom: 10px;
		right: 120px;
		z-index: 1000;
		pointer-events: auto;
	}

	.preview-container-content {
		position: relative;
	}

	.previewContainer {
		background-color: white;
		border-top-left-radius: 10px;
		border-top-right-radius: 10px;
		border-bottom-left-radius: 10px;
		padding: 4px;
		margin-left: 6px;
		margin-top: 6px;
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
		overflow: visible;
		z-index: 100;
	}
	.previewContainer:hover {
		border-radius: 5px;
		cursor: pointer;
	}
	.preview-message {
		color: black;
		border: none;
		font-family: area-variable, sans-serif;
		font-style: normal;
		font-variation-settings:
			'INKT' 0,
			'slnt' 0,
			'wdth' 100,
			'wght' 100;
		cursor: pointer;
		background: none;
		text-align: left;
		font-weight: 400;
		font-size: 14px;
		line-height: 20px;
		letter-spacing: 1%;
	}
	.close-button {
		position: absolute;
		top: -6px;
		left: 0px;
		width: 16px;
		height: 16px;
		background-color: white;
		color: black;
		padding: 2px;
		font-size: 10px;
		border: 0.1px solid black;
		border-radius: 50%;
		cursor: pointer;
		z-index: 1000;
	}
</style>
